// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"715":"1ecd7a85","1323":"f4df8d2a","4321":"e3d2af9b","8105":"3f4fc65e"}[chunkId] + ".chunk.css";
};